/** @module BarChartComponent */
import PercentageBarViz from '../vizs/PercentageBarViz'
import BaseComponent from './BaseComponent'

/**
 * # {componentLabel} (`class {componentClassName}`)
 * The percentage bar chart is used to display how values are distributed across lines and categories (in the stacked version).
 * 
 * ### Example Usage
 * ```javascript
 *   
 *   import {PercentageBar} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new PercentageBar($el, data, config);
 *   
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 2 or more columns.
 * 
 * Each row represents a data line. The first column should be the id/label of the stack, and the rest of the columns should represent each of the layers in the stack. Values will be transformed in percentage of the total value.
 * 
 * | category   | value1 |  value2  |  value3  |
 * | --------   | ------ |  ------  |  ------  |
 * |   Cat1     |    22.4|      15.4|      43.2|
 * |   Cat2     |    52.3|      29.3|      12.8|
 * |   Cat3     |    12.8|      34.1|      61.4|
 * 
 * {.data-table}
 * 
 * Each column will be assigned a different color, to distinguish them inside of each stack. 
 *
 * */
export default class PercentageBarComponent extends BaseComponent {
  static componentLabel = 'Percentage Bars'
  static vizClass = PercentageBarViz
  static dataFormat = [
    { index: 0, axis: 'x0', types: [String], role: 'id', roleLabel: 'Category' },
    { index: 1, axis: 'y0', types: [Number], role: 'value', roleLabel: 'Value' },
    { index: -1, axis: 'y0', label: 'Stack', types: [Number,null], role: 'value', roleLabel: 'Stacked value'}
  ]
  constructor($root, config, data) {
    super($root, config, data)
  }
  static defaultConfig = {
    title: this.componentLabel,
  }
}
